import React from "react";
import { useState } from "react";
import config from "../../configData.json";
import { getCurrentCart, clearCartData } from "../ShoppingCart/CartData";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { Redirect } from "../Utilities";
import ThankYou from "../../routes/ThankYou";

const decimalPlaces: number = 2;

const vat: number = Number(
  Math.round(parseFloat(config.VAT_RATE + "e" + decimalPlaces)) +
    "e-" +
    decimalPlaces
);
const currencyCode: string = config.CURRENCY_CODE;
const handling: number = Number(
  Math.round(parseFloat(config.HANDLING + "e" + decimalPlaces)) +
    "e-" +
    decimalPlaces
);
const insurance: number = Number(
  Math.round(parseFloat(config.INSURANCE + "e" + decimalPlaces)) +
    "e-" +
    decimalPlaces
);
const shippingDiscount: number = Number(
  Math.round(parseFloat(config.SHIPPING_DISCOUNT + "e" + decimalPlaces)) +
    "e-" +
    decimalPlaces
);
const discount: number = Number(
  Math.round(parseFloat(config.DISCOUNT + "e" + decimalPlaces)) +
    "e-" +
    decimalPlaces
);

export interface Props {
  Title: string;
  onCreateOrder: any;
}

interface State {
  order: any;
}

const PayPalCheckout = (props: Props, state: State) => {
  const [redirect, setredirect] = useState(false);
  const [orderDetails, setorderDetails] = useState<State>({ order: {} });
  let itemAmountTotal: number = 0;

  const [{ isPending }, dispatch] = usePayPalScriptReducer();

  let currentCart: any = getCurrentCart("Cart");
  let items: any = [];

  const getTotals = (countryCode: any): any => {
    let totalsResult = {
      totalItemsAmount: 0,
      totalItemsQuantity: 0,
      maxPaintingShippingPrice: 0,
      maxPrintShippingPrice: 0,
      totalItemsTaxAmount: 0,
      totalOverallAmount: 0,
    };
    if (currentCart && currentCart !== undefined && currentCart.length > 0) {
      if (items !== null && items.length > 0) {
        //get the totals from the paypal items array
        items.forEach((paypalItem: any) => {
          totalsResult.totalItemsAmount +=
            parseInt(paypalItem.unit_amount.value) *
            parseInt(paypalItem.quantity);
          totalsResult.totalItemsQuantity += parseInt(paypalItem.quantity);
          totalsResult.totalItemsTaxAmount +=
            Number(
              Math.round(
                parseFloat(paypalItem.tax.value + "e" + decimalPlaces)
              ) +
                "e-" +
                decimalPlaces
            ) * parseInt(paypalItem.quantity);
        });

        //get custom shipping rules
        if (countryCode !== "GB") {
          currentCart.forEach((item: any) => {
            if (
              item.shippingPrice &&
              item.shippingPrice !== undefined &&
              item.type === 0 &&
              item.shippingPrice > totalsResult.maxPaintingShippingPrice
            ) {
              totalsResult.maxPaintingShippingPrice += item.shippingPrice;
            }
            if (
              item.shippingPrice &&
              item.shippingPrice !== undefined &&
              item.type === 1 &&
              item.shippingPrice > totalsResult.maxPrintShippingPrice
            ) {
              totalsResult.maxPrintShippingPrice += item.shippingPrice;
            }
          });
        }

        //overall total amount
        let totalAmount: number =
          totalsResult.totalItemsAmount +
          totalsResult.totalItemsTaxAmount +
          (totalsResult.maxPaintingShippingPrice +
            totalsResult.maxPrintShippingPrice) +
          handling +
          insurance -
          shippingDiscount -
          discount;

        totalsResult.totalOverallAmount = Number(
          Math.round(parseFloat(totalAmount + "e" + decimalPlaces)) +
            "e-" +
            decimalPlaces
        );
      }
    }
    return totalsResult;
  };

  //builds the paypal items array
  const buildPayPalData = (): void => {
    if (currentCart && currentCart !== undefined && currentCart.length > 0) {
      currentCart.forEach((item: any) => {
        let itemTaxAmount: number = (item.singleUnitAmount / 100) * vat;
        let paypalItem: any = {
          name: item.item_name,
          quantity: item.quantity.toString(),
          description:
            "{ " +
            item.item_name +
            " " +
            item.medium +
            " " +
            item.size +
            " } , ",
          unit_amount: {
            currency_code: currencyCode,
            value: item.singleUnitAmount.toString(),
          },
          tax: {
            currency_code: currencyCode,
            value: itemTaxAmount.toString(),
          },
          //image_url: config.BASE_URI + item.thumbPath,
        };
        items.push(paypalItem);
      });
    }
  };

  if (itemAmountTotal === 0 && items.length === 0) {
    buildPayPalData();
  }

  const onCreateOrder = (data: any, actions: any) => {
    let shippingDetails: any = props.onCreateOrder();
    if (shippingDetails !== null && shippingDetails !== undefined) {
      let totals = getTotals(shippingDetails.country_code);
      return actions.order.create({
        intent: "CAPTURE",
        application_context: {},
        payment_source: {
          paypal: {
            name: {
              given_name: shippingDetails.full_name,
              surname: "",
            },
            email_address: shippingDetails.email_address,
            account_id: "",
            experience_context: {
              payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
              brand_name: config.BRAND_NAME,
              locale: config.LOCALE,
              landing_page: "LOGIN",
              shipping_preference: "SET_PROVIDED_ADDRESS",
              user_action: "PAY_NOW",
              return_url: config.RETURN_URL,
              cancel_url: config.CANCEL_URL,
            },
          },
        },
        purchase_units: [
          {
            shipping: {
              address: {
                address_line_1: shippingDetails.address_line_1,
                address_line_2: shippingDetails.address_line_2,
                admin_area_2: shippingDetails.admin_area_2,
                admin_area_1: "",
                postal_code: shippingDetails.postal_code,
                country_code: shippingDetails.country_code,
              },
            },
            amount: {
              currency_code: currencyCode,
              value: totals.totalOverallAmount.toFixed(2).toString(),
              breakdown: {
                item_total: {
                  currency_code: currencyCode,
                  value: totals.totalItemsAmount.toString(),
                },
                shipping: {
                  currency_code: currencyCode,
                  value:
                    totals.maxPaintingShippingPrice +
                    totals.maxPrintShippingPrice,
                },
                handling: {
                  currency_code: currencyCode,
                  value: handling,
                },
                tax_total: {
                  currency_code: currencyCode,
                  value: totals.totalItemsTaxAmount.toFixed(2).toString(),
                },
                insurance: {
                  currency_code: currencyCode,
                  value: insurance,
                },
                shipping_discount: {
                  currency_code: currencyCode,
                  value: shippingDiscount,
                },
                discount: {
                  currency_code: currencyCode,
                  value: discount,
                },
              },
            },
            items,
          },
        ],
      });
    }
  };

  const onApproveOrder = (data: any, actions: any) => {
    return actions.order.capture().then((details: any) => {
      //console.log(details);
      if (details.status === "COMPLETED") {
        let tranId: string = "";
        //clear shopping cart by re-initializing the cart
        clearCartData("Cart");
        details.purchase_units.forEach((item: any) => {
          tranId = item.payments.captures[0]?.id.toString();
        });
        //get ready to pass the order details to the thank you page
        setorderDetails({ order: details });
        //redirect to thank you page
        setredirect(true);
      }
    });
  };

  return (
    <>
      <div className="checkout">
        {isPending ? (
          <p>LOADING...</p>
        ) : (
          <PayPalButtons
            style={{ layout: "vertical" }}
            createOrder={(data, actions) => onCreateOrder(data, actions)}
            onApprove={(data, actions) => onApproveOrder(data, actions)}
          />
        )}
        {redirect ? (
          <Redirect path="/ThankYou" params={orderDetails.order} />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default PayPalCheckout;
